import { useState } from 'react';

import { RiExternalLinkLine } from '@remixicon/react';

import { AttachmentFragment } from '@spotify/confidence-graphql';

import { isRenamableArtifact } from '../../artifactUtils';
import { ArtifactMenu } from '../ArtifactMenu';
import { RenameArtifactDialog } from './RenameArtifactDialog';

interface ArtifactActionsMenuProps {
  artifact: AttachmentFragment;
  displayName: string;
  resourcePath?: string;
  resolvedDisplayName?: string;
  navigateLabel?: string;
  onNavigateToResource?: () => void;
  onDelete?: () => void;
}

export const ArtifactActionsMenu = ({
  artifact,
  displayName,
  resourcePath,
  resolvedDisplayName,
  navigateLabel,
  onNavigateToResource,
  onDelete,
}: ArtifactActionsMenuProps) => {
  const [renameOpen, setRenameOpen] = useState(false);
  const renamable = isRenamableArtifact(artifact);
  const fullUrl = resourcePath
    ? `${window.location.origin}${resourcePath}`
    : undefined;

  return (
    <>
      <ArtifactMenu.Root
        aria-label="Artifact actions"
        copyUrl={fullUrl}
        displayName={displayName}
        onRename={renamable ? () => setRenameOpen(true) : undefined}
        onDelete={onDelete}
      >
        {onNavigateToResource && (
          <ArtifactMenu.Item
            icon={<RiExternalLinkLine size={16} />}
            onClick={onNavigateToResource}
          >
            {navigateLabel ?? 'Go to resource'}
          </ArtifactMenu.Item>
        )}
      </ArtifactMenu.Root>
      {renamable && (
        <RenameArtifactDialog
          artifact={artifact}
          resolvedDisplayName={resolvedDisplayName}
          open={renameOpen}
          onOpenChange={setRenameOpen}
        />
      )}
    </>
  );
};
